import supabase from "../lib/supabase";

// Fallback defaults — used until app_config loads or if keys are missing
export const POINTS_PER_ORDER    = 25;
export const POINTS_SIGNUP_BONUS = 50;
export const POINTS_REFERRAL     = 50;
export const POINTS_PER_DOLLAR   = 15;

// Fetches live config from app_config table.
// Returns an object with the same keys; falls back to the constants above.
export async function fetchPointsConfig() {
  const { data } = await supabase
    .from("app_config")
    .select("key, value")
    .in("key", ["POINTS_PER_ORDER", "POINTS_SIGNUP_BONUS", "POINTS_REFERRAL", "POINTS_PER_DOLLAR"]);

  const map = Object.fromEntries((data ?? []).map((r) => [r.key, Number(r.value)]));
  return {
    POINTS_PER_ORDER:    map.POINTS_PER_ORDER    ?? POINTS_PER_ORDER,
    POINTS_SIGNUP_BONUS: map.POINTS_SIGNUP_BONUS ?? POINTS_SIGNUP_BONUS,
    POINTS_REFERRAL:     map.POINTS_REFERRAL     ?? POINTS_REFERRAL,
    POINTS_PER_DOLLAR:   map.POINTS_PER_DOLLAR   ?? POINTS_PER_DOLLAR,
  };
}
